<script>
	export let fontSize = 'text-lg'
</script>

<p class={fontSize}>
	<slot />
</p>
